import { useEffect } from 'react';
import './Ada.scss';

export function Ada({
  country,
  fingerprint,
}: {
  country?: string;
  fingerprint?: string;
}) {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('id', '__ada');
    script.setAttribute('data-handle', 'flywire');
    script.setAttribute('src', 'https://static.ada.support/embed2.js');
    script.onload = () => {
      window.adaEmbed.setMetaFields({
        origin: 'Embed2',
      });
    };

    document.body.appendChild(script);

    return () => {
      if (window.adaEmbed) {
        window.adaEmbed.stop();
      }
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (window.adaEmbed && (country || fingerprint)) {
      window.adaEmbed.setMetaFields({
        ...(country && { current_country: country }),
        ...(fingerprint && { fingerprint }),
      });
    }
  }, [country, fingerprint]);

  return null;
}
